import React from "react";
import { Quote, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "VANCE LLOYD",
  quote: "The Poseidon Project is a masterclass in tension. It felt like I was breathing the recycled air of a deep-sea sub. Decryption complete.",
  position: "VERIFIED INTEL"
}, {
  author: "CHERIE ADAM",
  quote: "A high-tech thriller that actually understands the tech. The short film adaptation is visually breathtaking and technically accurate.",
  position: "TACTICAL REVIEW"
}, {
  author: "DR. ARIES THORNE",
  quote: "I haven't been this gripped by a sci-fi narrative in years. Vetter has created a terrifyingly plausible future in the deep abyss.",
  position: "STRATEGIC ANALYST"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4115" id="reader-intel" ref={ref} className="dark bg-background py-20 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-12 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-primary font-sans text-lg font-semibold tracking-widest uppercase mb-3">
            Source: Encrypted
          </h2>
          <h3 className="text-foreground font-sans text-3xl md:text-4xl font-bold tracking-tight">
            READER INTEL: DECRYPTED
          </h3>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto text-lg font-mono">
            Recovered data fragments from operatives and readers across the global network regarding The Poseidon Project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((testimonial, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 150} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full border border-primary/20 shadow-lg bg-card/40 backdrop-blur-md relative overflow-hidden group hover:border-primary/40 transition-all duration-300">
                {}
                <Quote className="absolute top-2 right-4 size-32 text-primary/10 -rotate-12 pointer-events-none" />

                <CardContent className="p-8 flex flex-col h-full relative z-10">
                  {}
                  <div className="flex gap-1 mb-6 text-primary">
                    {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="size-4 fill-current shadow-[0_0_8px_rgba(0,255,255,0.5)]" strokeWidth={0} />)}
                  </div>

                  <blockquote className="flex-grow font-mono text-base text-foreground/90 leading-relaxed italic mb-6 border-l-2 border-primary/30 pl-4">
                    "{testimonial.quote}"
                  </blockquote>

                  <div className="mt-auto border-t border-primary/20 pt-4">
                    <div className="font-sans font-bold text-primary text-lg tracking-wider uppercase">
                      {testimonial.author}
                    </div>
                    <div className="text-muted-foreground font-mono text-xs font-medium tracking-widest">
                      
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}